export default __webpack_public_path__ + "static/media/linkedin.69a3a5c0.png";